import React from 'react';
import ReactDOM from "react-dom";
import HelpComponent from '../HelpComponent';

class MoveModelOption extends React.Component{
    constructor(){
        super();
        this.state={
            isSettingOpen:false,
            cover : "null",
            helpMode : "None"
        };
    }
    deleteLayerList(layer){
        const Layer = {
            TITLE:layer.layerName,
            TYPE:layer.layerType
        };
        this.props.deleteLayerList(Layer);
    }
    gotoLayer(){
        var MoveModelLayer = this.props.layer.layerHandel;
        MoveModelLayer.goto();
    }
    settingOpen(){
        this.setState({ isSettingOpen: !this.state.isSettingOpen });
    }
    coverChange(event){
        var cover = event.target.value;
        var MoveModelLayer = this.props.layer.layerHandel;
        if(cover === "null"){
            MoveModelLayer.setOverlayName();
            window.main.OView.updateScreen();
        }            
        else{
            MoveModelLayer.setOverlayName(cover);
            window.main.OView.updateScreen();
        }            
        this.setState({cover : cover});
    }
    onHelpClick(mode){
        this.setState({helpMode:mode})
    }
    render(){
        const LayerList_2D = this.props.LayerList_2D;
        const Layer = this.props.layer;
        if(this.state.helpMode === "MoveModelHelp" ){
            ReactDOM.render(<HelpComponent videoSrc="https://www.youtube.com/embed/1xkg_otY5Vs" onHelpClick={(e)=>this.onHelpClick(e)} />,document.getElementById('Help'));
        }   
        else if(this.state.helpMode === "None"){
            ReactDOM.unmountComponentAtNode(document.getElementById('Help'));      
        }
        return(
            <div className="ts accordion item">
                <div className="ts grid">
                    <div className="ts ten wide column"  style={{alignSelf: 'center'}}>
                        <div className="ts grid">
                            <div className="ts two wide column">
                                <i className="large find icon"></i>
                            </div>
                            <div className="ts fourteen wide column" style={{alignSelf: 'center'}}>
                                <h6 className="layerNameCSS">{Layer.layerName}
                                    <button className="ts circular pulsing mini icon button" style={{fontSize:"10px"}} onClick={(e)=>this.onHelpClick("MoveModelHelp")}>
                                        <i className="help small icon" style={{color:"#919191"}}></i>
                                    </button>
                                </h6>
                            </div>
                        </div>                      
                    </div>
                    <div className="ts two wide column" style={{cursor:"pointer"}} onClick={(e)=>this.deleteLayerList(Layer)} data-tooltip-position="top center" data-tooltip-type="label" data-tooltip="關閉圖層">
                        <i className="large remove circle outline icon"></i>
                    </div>
                    <div className="ts two wide column" style={{cursor:"pointer"}} onClick={(e)=>this.gotoLayer()} data-tooltip-position="top center" data-tooltip-type="label" data-tooltip="前往圖層位置">
                        <i className="large marker icon"></i>
                    </div>
                    <div className="ts two wide column" style={{cursor:"pointer"}} onClick={(e)=>this.settingOpen()} data-tooltip-position="top center" data-tooltip-type="label" data-tooltip="圖層設定">
                        <i className="large setting icon"></i>
                    </div>
                </div>
                {
                    this.state.isSettingOpen?
                    <div className="ts very narrow container segment" >                        
                        <div className="ts grid">
                            <div className="ts ten wide column" style={{alignSelf: 'center'}}>
                                <h6 className="layerNameCSS">影像披覆：</h6>
                            </div>
                            <div className="ts six wide column">
                                <select className="ts borderless basic dropdown" onChange={(e)=>this.coverChange(e)} value={this.state.cover} style={{width:"100%"}}>
                                    <option value="null">無</option>
                                    {
                                        LayerList_2D.map(
                                            (layer)=>
                                                <option value={layer.layerName}>{layer.layerName}</option> 
                                        )
                                    }
                                </select>
                            </div>
                        </div>
                    </div> : null
                }
                
            </div>
        );
    }
}
class MoveModelLayer extends React.Component{
    constructor()
    {
        super();
        this.state = {
            isChecked:false,
            MoveModelLayer:{}
        };   
        this.MoveModelLayerChecked = this.MoveModelLayerChecked.bind(this);

        // Member Variables
        this.vWidgetTimeline = null;
        this.vWidgetTimelinePlayer = null;

        this.vGltfCar = null;
        this.vTheta = 52.0; // 0~360
        this.vDateStart = new Date().getTime();
        this.vDateEnd = this.vDateStart + 10 * 1000;

    }
    componentDidUpdate(){
        if(this.props.deleteList.layerName === this.props.layer.TITLE){
            let isChecked = this.state.isChecked;
            if (isChecked)
            {
                // Hide Layer & Timeline    // xj4 
                this.vWidgetTimeline.hide();
                this.vWidgetTimelinePlayer.hide();

                // Update UI
                window.main.OView.removeLayer(this.state.MoveModelLayer);
                window.alertify.error("已關閉圖層："+this.props.layer.TITLE);
                isChecked = !isChecked;
                this.setState({isChecked:isChecked,MoveModelLayer:{}});
            }            
        }
    }

    UpdateModel()
    {
        let delta = (this.vWidgetTimeline._NowTime - this.vDateStart) * 0.001;

        if (this.vCustomLayer !== null) {
            // Update Model Pos
            let pos = new window.GeoPoint(120.72767596111555, 24.34817, 179);
            window.GetEPSGEngine().Transfer(4326, 3826, pos); // (source, target, coord)

            pos.x += Math.cos((this.vTheta / 360) * Math.PI * 2) * delta * 27.78;   // Speed: 100 km/hr = 100000m/hr = 1667 m/min = 27.78 m/s
            pos.y += Math.sin((this.vTheta / 360) * Math.PI * 2) * delta * 27.78;

            window.GetEPSGEngine().Transfer(3826, 4326, pos);
            this.vGltfCar.update({ position: pos });
        }
    }
    UpdateCamera()
    {
        // Update Camera Pos
        let tmpPos = window.main.OView.camera.pos;
        window.GetEPSGEngine().Transfer(4326, 3826, tmpPos);
        tmpPos.x += Math.cos((this.vTheta / 360) * Math.PI * 2) * 3 * 27.78;   // Speed: 100 km/hr = 100000m/hr = 1667 m/min = 27.78 m/s
        tmpPos.y += Math.sin((this.vTheta / 360) * Math.PI * 2) * 3 * 27.78;   // Speed: 100 km/hr = 100000m/hr = 1667 m/min = 27.78 m/s

        window.GetEPSGEngine().Transfer(3826, 4326, tmpPos);

        let v = window.main.OView.camera.v;
        let up = window.main.OView.camera.up;
        let camera = new window.ov.Camera(tmpPos, v, up);
        window.main.OView.gotoCamera(camera, true);
    }
    updateScreen(time)
    {
        window.main.OView.updateScreen();
        window.main.OView.vMoveModelLayerCotainer.UpdateModel();
        window.requestAnimationFrame(window.main.OView.vMoveModelLayerCotainer.updateScreen);
    }

    // Set
    SetTimeEvent()
    {
        const layerThis = this;

        window.main.OView.addTimeEvent({
            start: this.vDateStart,
            end: this.vDateEnd,
            title: "測試模型移動",
            onEnter: function () {
                layerThis.updateScreen(); // 不確定更新速度，考慮改成 setInterval，自己控制更新秒數
            },
            onLeave: function () {
                let pos = new window.GeoPoint(120.72767596111555, 24.34817, 179);
                layerThis.vGltfCar.update({ position: pos });
            }
        });

        this.vWidgetTimeline.addEventListener("Stop", function(){console.log("In New EventListener: Stop");});
        this.vWidgetTimelinePlayer.addEventListener("Play", function(){console.log("In New EventListener: Play");});
        this.vWidgetTimelinePlayer.addEventListener("Pause", function(){console.log("In New EventListener: Pause");});
    }
    StopTimeEvnet()
    {
        console.log("Time Stop La~~~"); // xj3
    }

    MoveModelLayerChecked(layer){
        let isChecked = this.state.isChecked;
        const layerThis = this;             
        if (!isChecked)
        {
            window.main.OView.addCustomLayer({
                layername: "MoveModel",
                callback: function (e, MoveModelLayer)
                {
                    if (e)
                    {
                        window.main.OView.vMoveModelLayerCotainer = layerThis;   // For external use

                        // Load Model
                        layerThis.vGltfCar = MoveModelLayer.addGLTFEntity({
                            position: new window.GeoPoint(120.72767596111555, 24.34817, 179),
                            src: "../../xjstest/data/car1.glb",
                            scale: 10,
                            rotate: { x: 0, y: 1, z: 0, w: 140 }
                        });

                        // Set Time UI
                        layerThis.vWidgetTimeline = new window.ov.Widget.Timeline({ 
                            view: window.main.OView, 
                            style: { left: "120px", bottom: "60px", width: "calc(100% - 120px)" },
                            startTime: layerThis.vDateStart, stopTime: layerThis.vDateEnd, isRepeat: true 
                        });
                        layerThis.vWidgetTimelinePlayer = new window.ov.Widget.TimelinePlayer({ 
                            view: window.main.OView, timeline: layerThis.vWidgetTimeline, playSpeed: 1, play: true, maxPlaySpeed: 10, minPlaySpeed: 1, playSpeedStep:0.1, minUpdateInterval: 33, 
                            style: { left: "88px", bottom: "56px" }
                        });
                        layerThis.SetTimeEvent();


                        // Set Offset
                        if (layer.OFFSET != null)
                        {
                            MoveModelLayer.setOffset(layer.OFFSET.x, layer.OFFSET.y, layer.OFFSET.z);
                        }

                        // Set Location
                        if (layer.LOCATION != null)
                        {
                            var Pos = new window.Geo3DPoint(layer.LOCATION.POS.x, layer.LOCATION.POS.y, layer.LOCATION.POS.z);
                            var V = new window.Geo3DPoint(layer.LOCATION.V.x, layer.LOCATION.V.y, layer.LOCATION.V.z);
                            var Up = new window.Geo3DPoint(layer.LOCATION.UP.x, layer.LOCATION.UP.y, layer.LOCATION.UP.z);
                            var Camera = new window.ov.Camera(Pos, V, Up);
                            window.main.OView.gotoCamera(Camera, true);
                        }
                        else
                        {
                            MoveModelLayer.goto();
                        }
                        
                        window.alertify.success("已開啟圖層："+layer.TITLE);
                        layerThis.props.setOpenLayer(layer,MoveModelLayer);                        
                        isChecked = !isChecked;
                        layerThis.setState({isChecked:isChecked,MoveModelLayer:MoveModelLayer});
                    }
                    else if(!e){
                        window.alertify.error("連結不到圖層:："+layer.TITLE);
                    }
                }
            });

            // ======================================================================            
        }
        else {
            // Hide Layer & TimeLine    // xj4 與淹水共用 timeline 的話，要在 Init 時 call get timeline func.
            this.vWidgetTimeline.hide();
            this.vWidgetTimelinePlayer.hide();

            // Update UI
            window.main.OView.removeLayer(this.state.MoveModelLayer);
            layerThis.props.deleteLayer(layer);
            window.alertify.error("已關閉圖層："+layer.TITLE);
            isChecked = !isChecked;    
            layerThis.setState({isChecked:isChecked,MoveModelLayer:{}});        
        }                      
    }    
    render(){
        const layer = this.props.layer;
        return(
            <div className="ts checkbox">
                <input type="checkbox" name="MoveModelLayer" id={layer.TITLE} checked={this.state.isChecked} onChange={(e)=>this.MoveModelLayerChecked(layer)}></input>
                <label htmlFor={layer.TITLE}>{layer.TITLE}</label>
            </div>
        );
    }
}

export  {MoveModelLayer,MoveModelOption};